import { SelectType } from "../state.js";
//#region src/engine/modules/editor/utils/selection.ts
function getSelectTypeIds(selectedMap) {
	return Object.entries(selectedMap).reduce((acc, [id, type]) => {
		if (type === SelectType.table) acc.tableIds.push(id);
		else if (type === SelectType.memo) acc.memoIds.push(id);
		else if (type === SelectType.tableGroup) acc.tableGroupIds.push(id);
		return acc;
	}, {
		tableIds: [],
		memoIds: [],
		tableGroupIds: []
	});
}
//#endregion
export { getSelectTypeIds };
